module.exports = __webpack_public_path__ + "static/img/083.14b552a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/083.png
// module id = gPXh
// module chunks = 0